<template>
  <div style="height:100%">
    <div class="manage">
      <div class="content">
        <div class="operation">
          <el-button
            type="primary"
            :round="false"
            size="small"
            icon="el-icon-plus"
            @click="showBrand = true"
          >
            <span>添加新品牌</span>
          </el-button>
          <span style="margin-left:20px;">品牌名称：</span>
          <el-input
            v-model="screenValue"
            placeholder="新品牌"
            size="small"
            style="width:200px;margin-right:5px;"
          ></el-input>
          <el-button
            type="primary"
            :round="false"
            size="small"
            icon="el-icon-search"
            @click="screen"
          >
            <span>筛选</span>
          </el-button>
        </div>
        <div class="brandList">
          <template>
            <el-table
              :border="true"
              :data="tableData"
            >
              <el-table-column type="index"></el-table-column>
              <el-table-column
                prop="name"
                label="品牌名"
                width="180"
              ></el-table-column>
              <el-table-column label="LOGO" width="180">
                <template slot-scope="scope">
                  <el-image
                    style="width: 30px; height: 30px"
                    :src="scope.row.image"
                    fit="fill"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="sort"
                label="排序"
                width="180"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="Otherpage">
          <div class="changePage">
            <div @click="upPage" class="btnColor">
              <span>上一页</span>
            </div>
            <div>
              <span>{{ page }}</span>
            </div>
            <div @click="downPage" class="btnColor">
              <span>下一页</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <addBrand @close="closeadd" v-show="showBrand"></addBrand>
    <editBrand @close="closeEdit" v-show="showEdit" :row="newId"></editBrand>
  </div>
</template>

<script>
// 可以进行优化，添加和修改使用一个组件，根据传值的不同状态(添加为true,编辑为false)，判定状态，使用保存或修改
import addBrand from "@/components/commodity/addBrand.vue";
import editBrand from "@/components/commodity/editBrand.vue";
import { BrandList, delBrand } from "@/api/mall";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {
    addBrand,
    editBrand
  },
  data() {
    return {
      screenValue: "",
      newId: {},
      showEdit: false,
      showBrand: false,
      idx: 1,
      nowIDx: 0,
      value: "",
      input: "",
      page: "1",
      tableData: []
    };
  },
  watch: {
    screenValue() {
      if (this.screenValue == "") {
        this.getBrandlist();
      }
    }
  },
  methods: {
    // 关闭页面
    closeadd(item) {
      this.showBrand = item;
      this.getBrandlist();
    },
    closeEdit(item) {
      this.showEdit = item;
      this.getBrandlist();
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.showEdit = true;
      this.newId = row;
    },
    // 删除
    handleDelete(index, row) {
      console.log(index, row);
      let data = {
        token: this.token,
        id: row.id
      };
      delBrand(data).then(res => {
        console.log(res);
        this.getBrandlist();
      });
    },
    // 品牌列表
    getBrandlist() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        page: this.page
      };
      BrandList(data).then(res => {
        console.log(res);
        this.tableData = res.data;
      });
    },
    // 筛选
    screen() {
      if (this.screenValue == "") {
        this.$message("输入不许为空");
      } else {
        console.log(111);
        let data = {
          token: this.token,
          app_id: this.app_id,
          merch_id: this.merch_id,
          page: "1",
          name: this.screenValue
        };
        BrandList(data).then(res => {
          console.log(res);
          this.tableData = res.data;
        });
      }
    },
    upPage() {
      // 上一页
      this.page--;
      if (this.page == 0) {
        this.page = 1;
        this.getBrandlist();
      } else {
        this.getBrandlist();
      }
    },
    downPage() {
      // 下
      this.page++;
      console.log(this.page);
      this.getBrandlist();
      console.log(this.tableData.length);
      if (this.tableData.length == 0) {
        this.$message("请添加新品牌");
        this.page--;
        this.getBrandlist();
      }
    }
  },
  mounted() {
    this.getBrandlist();
  }
};
</script>

<style lang="scss" scoped>
el-table {
  height: calc(100% - 20px);
}
.manage {
  height: 100%;
  padding-left: 22px;
  padding-right: 72px;
  position: relative;
  .content {
    overflow: hidden;
    position: absolute;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 30px;
    .operation {
      height: 36px;
    }
    .brandList {
      height: 100%;
      margin-top: 20px;
    }
    .Otherpage {
      height: 34px;
      width: 200px;
      position: absolute;
      bottom: 0;
      left: 30px;
      .changePage {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        div {
          height: 100%;
          width: 30%;
          text-align: center;
          line-height: 34px;
        }
        .btnColor {
          background: #b0b5bb30;
        }
      }
    }
  }
}
</style>
